import { render, staticRenderFns } from "./TiposContratos.view.vue?vue&type=template&id=7876ab4c"
import script from "./TiposContratos.view.vue?vue&type=script&lang=js"
export * from "./TiposContratos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports